module.exports = __webpack_public_path__ + "img/PTG.593dff99.svg";